import React, { useState, useRef } from "react";
import swipeBanner from "../../images/swipebanner.jpg";

const slides = [
  {
    id: 1,
    image: swipeBanner,
    alt: "Banner 86HSK"
  }
];

export default function BannerSwipeSection() {
  const [current, setCurrent] = useState(0);
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);

  const goNext = () => setCurrent((prev) => (prev + 1) % slides.length);
  const goPrev = () => setCurrent((prev) => (prev - 1 + slides.length) % slides.length);

  const onTouchStart = (e) => {
    touchStartX.current = e.changedTouches[0].clientX;
  };

  const onTouchEnd = (e) => {
    touchEndX.current = e.changedTouches[0].clientX;
    const diff = touchStartX.current - touchEndX.current;

    if (Math.abs(diff) < 50 || slides.length <= 1) return;
    if (diff > 0) goNext();
    else goPrev();
  };

  return (
    <section className="px-4 sm:px-6 lg:px-8 mt-2 mb-10 bg-transparent">
      <div className="max-w-7xl mx-auto">
        <div
          className="relative overflow-hidden rounded-2xl shadow-xl"
          onTouchStart={onTouchStart}
          onTouchEnd={onTouchEnd}
        >
          <div
            className="flex transition-transform duration-500 ease-out"
            style={{ transform: `translateX(-${current * 100}%)` }}
          >
            {slides.map((slide) => (
              <div key={slide.id} className="min-w-full">
                <img
                  src={slide.image}
                  alt={slide.alt}
                  className="w-full h-auto max-h-[360px] md:max-h-[420px] object-cover"
                  loading="lazy"
                />
              </div>
            ))}
          </div>

          {slides.length > 1 && (
            <>
              <button
                type="button"
                onClick={goPrev}
                className="absolute left-3 top-1/2 -translate-y-1/2 h-9 w-9 rounded-full bg-black/40 text-white hover:bg-black/60"
                aria-label="Previous banner"
              >
                ‹
              </button>
              <button
                type="button"
                onClick={goNext}
                className="absolute right-3 top-1/2 -translate-y-1/2 h-9 w-9 rounded-full bg-black/40 text-white hover:bg-black/60"
                aria-label="Next banner"
              >
                ›
              </button>
            </>
          )}
        </div>
      </div>
    </section>
  );
}